<template>
  <div class="templates-page">

    <!-- ===== PAGE TITLE ===== -->
    <div class="page-title">
      <h1>Templates Library</h1>
      <p>Browse, customize, and manage templates for customer communication.</p>
    </div>

    <!-- ===== TOOLBAR ===== -->
    <div class="toolbar">

      <div class="toolbar-left">
        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input placeholder="Search templates..." />
        </div>

        <button class="filter-btn">
          Category
          <span class="material-symbols-outlined">expand_more</span>
        </button>

        <button class="filter-btn">
          Channel
          <span class="material-symbols-outlined">expand_more</span>
        </button>
      </div>

      <div class="toolbar-right">
        <button class="ghost-btn">
          <span class="material-symbols-outlined">tune</span>
          Filters
        </button>

        <button class="primary-btn">
          <span class="material-symbols-outlined">add</span>
          Create Template
        </button>
      </div>

    </div>

    <!-- ===== CATEGORY TABS ===== -->
    <div class="category-tabs">
      <button class="active">Review Requests</button>
      <button>Referral Requests</button>
      <button>Follow-ups</button>
      <button>Reminders</button>
    </div>

    <!-- ===== TEMPLATE GRID ===== -->
    <div class="templates-grid">

      <div class="template-card" v-for="template in templates" :key="template.id">

        <div class="template-header">
          <h3>{{ template.name }}</h3>
          <span :class="['channel', template.channel.toLowerCase()]">
            {{ template.channel }}
          </span>
        </div>

        <p class="snippet">
          {{ template.snippet }}
        </p>

        <div class="template-actions">
          <button>Preview</button>
          <button>Use</button>
          <button>Edit</button>
          <button>Duplicate</button>
          <button class="danger">Delete</button>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'TemplatesLibraryScreen',

  data() {
    return {
      templates: [
        {
          id: 1,
          name: 'Polite Review Request',
          snippet: 'Hi {{name}}, we hope you enjoyed your experience. Would you mind leaving us a quick review?',
          channel: 'Email'
        },
        {
          id: 2,
          name: 'Friendly Referral Invite',
          snippet: 'Know someone who might love our service? Share your referral link and earn rewards!',
          channel: 'SMS'
        },
        {
          id: 3,
          name: 'Follow-up Reminder',
          snippet: 'Just checking in {{name}}. We would truly appreciate your feedback.',
          channel: 'WhatsApp'
        }
      ]
    }
  }
}
</script>
<style scoped>
.templates-page {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* TITLE */
.page-title h1 {
  font-size: 28px;
  font-weight: 800;
}

.page-title p {
  font-size: 14px;
  color: #64748b;
}

/* CATEGORY TABS */
.category-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.category-tabs button {
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
}

.category-tabs button.active {
  background: #197fe6;
  color: white;
  border-color: #197fe6;
}

/* GRID */
.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(280px,1fr));
  gap: 14px;
}

/* CARD */
.template-card {
  background: white;
  border-radius: 16px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.template-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.template-header h3 {
  font-size: 14px;
  font-weight: 700;
}

/* SNIPPET */
.snippet {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

/* CHANNEL BADGES */
.channel {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.channel.email { background: #eff6ff; color: #197fe6; }
.channel.sms { background: #fef9c3; color: #854d0e; }
.channel.whatsapp { background: #dcfce7; color: #166534; }

/* ACTIONS */
.template-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.template-actions button {
  height: 32px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.template-actions button:hover {
  background: #f8fafc;
}

.template-actions button.danger {
  color: #dc2626;
}

/* SHARED TOOLBAR SYSTEM */
.toolbar {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* SEARCH */
.search-box {
  height: 40px;
  background: white;
  border-radius: 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  min-width: 240px;
}

.search-box input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
}

/* FILTER BTN */
.filter-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
}

/* BUTTONS */
.primary-btn {
  height: 40px;
  padding: 0 16px;
  background: #197fe6;
  border-radius: 10px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
}

.ghost-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
}

/* MOBILE */
@media(max-width:768px) {
  .templates-page { padding: 16px; }
  .templates-grid { grid-template-columns: 1fr; }
  .search-box { width: 100%; }
}
/* ================= PAGE ================= */

.templates-page {
  padding: 28px;
  display: flex;
 flex-direction: column;
  gap: 18px;
  background: #f6f7f8;
  min-height: 100vh;
}

/* ================= TITLE ================= */

.page-title h1 {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
}

.page-title p {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

/* ================= TOOLBAR ================= */

.toolbar {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

/* ================= SEARCH ================= */

.search-box {
  height: 40px;
  background: white;
  border-radius: 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  min-width: 240px;
  flex: 1;
}

.search-box span {
  font-size: 18px;
  color: #94a3b8;
}

.search-box input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
  background: transparent;
}

/* ================= FILTER BUTTON ================= */

.filter-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: 0.2s;
  white-space: nowrap;
}

.filter-btn:hover {
  background: #f8fafc;
}

/* ================= BUTTON SYSTEM ================= */

.primary-btn {
  height: 40px;
  padding: 0 16px;
  background: #197fe6;
  border-radius: 10px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  cursor: pointer;
  transition: 0.2s;
  white-space: nowrap;
}

.primary-btn:hover {
  background: #166fd1;
}

.ghost-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: 0.2s;
  white-space: nowrap;
}

.ghost-btn:hover {
  background: #f8fafc;
}

/* ================= CATEGORY TABS ================= */

.category-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.category-tabs button {
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: 0.2s;
  white-space: nowrap;
}

.category-tabs button:hover {
  background: #f8fafc;
}

.category-tabs button.active {
  background: #197fe6;
  color: white;
  border-color: #197fe6;
}

/* ================= GRID ================= */

.templates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 14px;
}

/* ================= TEMPLATE CARD ================= */

.template-card {
  background: white;
  border-radius: 16px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: 0.2s;
}

.template-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 34px rgba(0,0,0,0.06);
}

/* ================= CARD HEADER ================= */

.template-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.template-header h3 {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

/* ================= SNIPPET ================= */

.snippet {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

/* ================= CHANNEL BADGES ================= */

.channel {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.channel.email {
  background: #eff6ff;
  color: #197fe6;
}

.channel.sms {
  background: #fef9c3;
  color: #854d0e;
}

.channel.whatsapp {
  background: #dcfce7;
  color: #166534;
}

/* ================= ACTIONS ================= */

.template-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.template-actions button {
  height: 32px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: 0.2s;
}

.template-actions button:hover {
  background: #f8fafc;
}

.template-actions button.danger {
  color: #dc2626;
}

/* ================= MOBILE ================= */

@media(max-width:768px) {

  .templates-page {
    padding: 16px;
  }

  .toolbar {
    flex-direction: column;
  }

  .toolbar-left,
  .toolbar-right {
    width: 100%;
  }

  .search-box {
    width: 100%;
    min-width: unset;
  }

  .filter-btn,
  .ghost-btn,
  .primary-btn {
    flex: 1;
    justify-content: center;
  }

  .templates-grid {
    grid-template-columns: 1fr;
  }

  .template-actions {
    flex-direction: column;
  }

  .template-actions button {
    width: 100%;
  }
}

</style>